import React, { useState, useEffect } from 'react';
import ChartCapitalStructure from './ChartCapitalStructure';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChartCapitalStructureData(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChartCapitalStructureData(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartCapitalStructureData = () => {
  const [dataSet, setDataSet] = useState('dataCapitalStructure');
  const [data, loading, error] = useData(dataSet);

  return (
    <>
      <ChartCapitalStructure data={data} error={error} loading={loading} />
    </>
  );
};

export default ChartCapitalStructureData;
